import script from "./ListPokemons.vue?vue&type=script&setup=true&lang=js"
export * from "./ListPokemons.vue?vue&type=script&setup=true&lang=js"

import "./ListPokemons.vue?vue&type=style&index=0&id=0415d79e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0415d79e"]])

export default __exports__